module.exports = __webpack_public_path__ + "img/energy.f60349f.png";